import { render, staticRenderFns } from "./PaperSync.vue?vue&type=template&id=388f81a8&scoped=true&"
import script from "./PaperSync.vue?vue&type=script&lang=js&"
export * from "./PaperSync.vue?vue&type=script&lang=js&"
import style0 from "./PaperSync.vue?vue&type=style&index=0&id=388f81a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f81a8",
  null
  
)

export default component.exports